import { AdditionalInterestAndInsured } from 'src/configs/APISchemas/Application.schema';

export const getDisplayedInterestedParty = (
  interestedParty: AdditionalInterestAndInsured | undefined,
) => {
  if (!interestedParty) {
    return '-';
  }

  const interestedPartyFirstName = interestedParty.firstName;
  const interestedPartyLastName =
    interestedParty.lastName === '.' ? '' : interestedParty.lastName;

  return `${interestedPartyFirstName} ${interestedPartyLastName}`.trim();
};
